import React from 'react';

import ChatIcon from 'Assets/icons/chat-bubble.svg';
import PenIcon from 'Assets/icons/pen-simple.svg';
import TrashIcon from 'Assets/icons/trash.svg';

const iconButton =
    'tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-charcoal-50 hover:tw-bg-charcoal-15 hover:tw-text-charcoal focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue';

/**
 * A column heading: the name exactly as typed, a note icon when the column has a note
 * (its text on hover), and — for editors — note, rename and delete on hover.
 */
export default function ColumnHeading({ column, canEdit, onNote, onRename, onDelete }) {
    return (
        <th className="tw-group tw-relative tw-min-w-[150px] tw-border-b tw-border-blue-25 tw-bg-blue-10 tw-px-3 tw-py-2.5 tw-text-end tw-align-top tw-font-medium tw-text-charcoal">
            <div className="tw-flex tw-items-center tw-justify-end tw-gap-x-1.5">
                {column.note && (
                    <button type="button" onClick={() => onNote(column)} title={column.note} aria-label={$t('Column note')} className="tw-text-blue">
                        <ChatIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    </button>
                )}
                <span className="tw-whitespace-pre">{column.name}</span>
            </div>
            <div className="tw-mt-0.5 tw-text-2xs tw-font-light tw-text-charcoal-50">{$t('value · % of line')}</div>
            {canEdit && (
                <div className="tw-absolute tw-end-1 tw-top-full tw-z-10 tw-hidden tw-gap-x-0.5 tw-rounded-lg tw-border tw-border-grey tw-bg-white tw-p-0.5 tw-shadow-primary group-focus-within:tw-flex group-hover:tw-flex">
                    <button
                        type="button"
                        className={iconButton}
                        onClick={() => onNote(column)}
                        title={column.note ? $t('Edit column note') : $t('Add column note')}
                    >
                        <ChatIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    </button>
                    <button type="button" className={iconButton} onClick={() => onRename(column)} title={$t('Rename column')}>
                        <PenIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    </button>
                    <button type="button" className={iconButton} onClick={() => onDelete(column)} title={$t('Delete column')}>
                        <TrashIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    </button>
                </div>
            )}
        </th>
    );
}
